import { render, staticRenderFns } from "./commonTableSecretaryModal.vue?vue&type=template&id=33415a90&"
import script from "./commonTableSecretaryModal.vue?vue&type=script&lang=js&"
export * from "./commonTableSecretaryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports